import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {MediaImage} from './media-image.model';
import * as MediaImageActions from './media-image.actions';

export const mediaImagesFeatureKey = 'mediaImages';

export interface State extends EntityState<MediaImage> {
  // additional entities state properties
}

export const adapter: EntityAdapter<MediaImage> = createEntityAdapter<MediaImage>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(MediaImageActions.addMediaImage,
    (state, action) => adapter.addOne(action.mediaImage, state)
  ),
  on(MediaImageActions.upsertMediaImage,
    (state, action) => adapter.upsertOne(action.mediaImage, state)
  ),
  on(MediaImageActions.addMediaImages,
    (state, action) => adapter.addMany(action.mediaImages, state)
  ),
  on(MediaImageActions.upsertMediaImages,
    (state, action) => adapter.upsertMany(action.mediaImages, state)
  ),
  on(MediaImageActions.updateMediaImage,
    (state, action) => adapter.updateOne(action.mediaImage, state)
  ),
  on(MediaImageActions.updateMediaImages,
    (state, action) => adapter.updateMany(action.mediaImages, state)
  ),
  on(MediaImageActions.deleteMediaImage,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(MediaImageActions.deleteMediaImages,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(MediaImageActions.loadMediaImages,
    (state, action) => adapter.setAll(action.mediaImages, state)
  ),
  on(MediaImageActions.clearMediaImages,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
